module.exports = __webpack_public_path__ + "img/img84.70b0cc7d.svg";